import DashboardView from './dashboard-view';

export default DashboardView;
